import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Bulk Save icon — document with an inner building/house shape.
 * Uses `currentColor` so the parent element drives the tint (white where the
 * parent colour is white).
 *
 * The artwork spans 18.2 units and was drawn edge-to-edge, filling 91% of a 20-unit box where
 * the sibling icons fill 65–80% of theirs. Rendered at the same pixel size it therefore came out
 * visibly larger than its neighbours on the floating bar. The viewBox is padded to 23.95 units —
 * the glyph centred, untouched — so it fills 76%, matching EditIcon, and renders at the same
 * optical size. Restores the padding lost when a master merge reverted this line.
 */
const BulkSaveIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="-2.87 -2.87 23.95 23.95" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g>
      <path
        d="M0 2.56621C0.000120678 1.88565 0.270717 1.23319 0.751953 0.751953C1.23319 0.270717 1.88565 0.000120678 2.56621 0H12.8338L12.9705 0.0136719C13.1051 0.0405666 13.2303 0.10662 13.3287 0.205078L17.9949 4.87129C18.1261 5.00246 18.1999 5.18072 18.2 5.36621V15.6338C18.1999 16.3143 17.9293 16.9668 17.448 17.448C16.9668 17.9293 16.3143 18.1999 15.6338 18.2H2.56621C1.88565 18.1999 1.23319 17.9293 0.751953 17.448C0.270717 16.9668 0.000120545 16.3143 0 15.6338V2.56621ZM5.13379 16.8H13.0662V10.7338H5.13379V16.8ZM1.4 15.6338C1.40012 15.943 1.52311 16.2395 1.7418 16.4582C1.96048 16.6769 2.25696 16.7999 2.56621 16.8H3.73379V10.0338C3.73379 9.64719 4.04719 9.33379 4.43379 9.33379H13.7662C14.1528 9.33379 14.4662 9.64719 14.4662 10.0338V16.8H15.6338C15.943 16.7999 16.2395 16.6769 16.4582 16.4582C16.6769 16.2395 16.7999 15.943 16.8 15.6338V5.65605L12.5439 1.4H5.13379V4.66621H11.9C12.2864 4.66621 12.5998 4.97982 12.6 5.36621C12.6 5.75281 12.2866 6.06621 11.9 6.06621H4.43379C4.04719 6.06621 3.73379 5.75281 3.73379 5.36621V1.4H2.56621C2.25696 1.40012 1.96048 1.52311 1.7418 1.7418C1.52311 1.96048 1.40012 2.25696 1.4 2.56621V15.6338Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default BulkSaveIcon;
